import React from 'react';
import { useIntl } from 'react-intl';
import { StyledTitle } from './styles';

export const Title = () => {
  const intl = useIntl();

  return <StyledTitle>{intl.formatMessage({ id: 'mindbody_agreement' })}</StyledTitle>;
};
